export const getFromLocalStorage = key => localStorage.getItem(key);

export const setToLocalStorage = (key, obj) => localStorage.setItem(key, obj);

export const removeFromLocalStorange = key => localStorage.removeItem(key);
